<template>
  <PinBtn
    v-if="!hide_pin_controls"
    :item="item"
    :myKey="myKey"></PinBtn>
  <PinAutoRefreshBtn
    v-if="!currentTemplate && !hide_activate_controls"
    :item="item"
    :myKey="myKey" />
  <v-card
    :style="`opacity: ${opaqueMode ? 1 : 0.5}`"
    flat
    class="mb-2 px-2 scene-asset-card"
    v-if="deluge.pinned_svars"
    style="
      width: 100%;
      background: var(--v-field-color);
      display: flex;
      flex-direction: column;
      padding-top: 4px;
    ">
    <!-- Always show AssetsDropdown for asset type - the tagQuery filters by asset_tag_filter -->
    <AssetsDropdown
      :item="item"
      :tagQuery="requireTags"
      :readOnlyMode="readOnlyMode" />
    <div
      v-if="item.asset_tag_filter && !disableFiltering"
      style="display: flex; flex-wrap: wrap; padding: 4px 0">
      <div v-for="tag_filter in item['asset_tag_filter'].split(',')">
        <v-chip
          v-if="!tag_filter.startsWith('!')"
          size="small"
          style="opacity: 0.5"
          :key="tag_filter"
          small
          label
          class="mx-1">
          {{ tag_filter }}
        </v-chip>
        <v-chip
          v-else
          @click="
            toggleFilter(tag_filter);
            setRequireTags();
          "
          size="small"
          :color="activeFilters.has(tag_filter) ? 'orange' : 'primary'"
          :style="{ opacity: activeFilters.has(tag_filter) ? 1 : 0.8 }"
          small
          label
          class="mx-1">
          {{ tag_filter.startsWith('!') ? tag_filter.slice(1) : tag_filter }}
        </v-chip>
      </div>
    </div>
  </v-card>

  <div style="display: flex">
    <v-icon
      v-if="currentTemplate?.src_scene_data?.[myKey]"
      variant="flat"
      class="ml-3 refresh-button"
      style="height: 56px !important"
      @click="handleUserIntent(myKey, originLevel)"
      :style="unLockedMode ? 'opacity: 0.3' : 'opacity: 0.7'"
      :title="
        unLockedMode
          ? 'Value inherits from Template or Source'
          : 'Value locked. (Will not inherit from Template or Source)'
      "
      :icon="
        unLockedMode ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline'
      "></v-icon>

    <!-- <PinSendNowBtn
      v-if="!currentTemplate"
      :item="item"
      :myKey="myKey" /> -->
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import PinBtn from './PinBtn.vue';
import PinAutoRefreshBtn from './PinAutoRefreshBtn.vue';
import PinSendNowBtn from './PinSendNowBtn.vue';
import { inheritanceHandler } from '../../../utils/inheritanceHandler';
import { defineProps, ref, watch, onBeforeMount } from 'vue';
import { computed } from 'vue';
import { isOpaque } from './utils.js';
import EditAssetModal from '../../Assets/EditAssetModal.vue';
import AssetsDropdown from '../AssetsTemplatesDropdown.vue';
const props = defineProps([
  'currentTemplate',
  'originLevel',
  'resetFunc',
  'item',
  'myKey',
  'hideicons',
  'multiple',
  'hide_pin_controls',
  'hide_activate_controls',
  'readOnlyMode',
  'disableFiltering',
]);

const emit = defineEmits(['valueChanged']);

watch(
  () => props.item.value,
  () => {
    emit('valueChanged', [props.myKey, props.item.value]);
  }
);

const activeFilters = ref(new Set());

const unLockedMode = ref(props.item.keyInherited);

function handleUserIntent(myKey, originLevel) {
  if (props.readOnlyMode) return;

  unLockedMode.value = !unLockedMode.value;
  props.item.userIntent = unLockedMode.value === true ? 'remove' : 'keep';
  if (unLockedMode.value === true) {
    props.resetFunc(myKey, originLevel);
  }
}

const valueEdited = ref(false);
const opaqueMode = computed(() => {
  return isOpaque(deluge, props);
});
onBeforeMount(() => {
  if (props.multiple) {
    if (!props.item.value) {
      props.item.value = [];
    }
    let newList = [];
    for (const assetUid of props.item.value) {
      newList.push(deluge.assets[assetUid]);
    }
    props.item.value = newList;
  }
  setRequireTags();
});

watch(
  () => props.item.value,
  () => {
    valueEdited.value = true;
  }
);

watch(
  () => props.item.value,
  () => {
    inheritanceHandler(props.item);
  },
  // It's required to run this watcher immediately
  // else the value will change before the handler tracks the initial value
  { immediate: true }
);
const requireTags = ref(null);
function setRequireTags() {
  // Handle missing or empty asset_tag_filter
  const tagFilterStr = props.item['asset_tag_filter'] || '';
  if (!tagFilterStr) {
    requireTags.value = { require: [], include: [] };
    return;
  }
  const tag_filters = tagFilterStr.split(',');
  let requireTagsTemp = [];
  for (const filter of tag_filters) {
    if (filter.startsWith('!')) {
      requireTagsTemp.push(filter.slice(1));
    }
  }
  let result = {
    require: requireTagsTemp,
    include: tag_filters.filter((tag) => !tag.startsWith('!')),
  };
  // convert tag names to tag uids using deluge.tags

  const requireUids = result.require.map((tag) => {
    return Object.values(deluge.tags).find((t) => t.name === tag)?.uid;
  });
  const includeUids = result.include.map((tag) => {
    return Object.values(deluge.tags).find((t) => t.name === tag)?.uid;
  });
  const activeUids = Array.from(activeFilters.value).map((tag) => {
    return Object.values(deluge.tags).find((t) => t.name === tag.slice(1))?.uid;
  });
  const requireUidsFiltered = requireUids.filter((uid) => {
    if (!uid) {
      console.log(`Tag ${uid} not found in deluge.tags`);
      return false;
    }
    if (activeUids.includes(uid)) {
      return false;
    }
    return true;
  });
  const includeUidsFiltered = includeUids.filter((uid) => {
    if (!uid) {
      console.log(`Tag ${uid} not found in deluge.tags`);
      return false;
    }
    return true;
  });
  requireTags.value = {
    require: requireUidsFiltered,
    include: includeUidsFiltered,
  };
  console.log(requireTags.value);
}

function toggleFilter(tag_filter) {
  if (activeFilters.value.has(tag_filter)) {
    activeFilters.value.delete(tag_filter);
  } else {
    activeFilters.value.add(tag_filter);
  }
}
</script>

<style scoped>
/* Darken the textarea field so it contrasts with the card container */
:deep(.v-field) {
  background: rgba(0, 0, 0, 0.35) !important;
}

/* Remove excess margins from card's direct children (loader, dropdown, chips) */
.scene-asset-card > :deep(div) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* Remove vertical margins from tag filter chips */
.scene-asset-card :deep(.v-chip) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
